import InnerComponent from '@/entities/InnerComponent';
import BadgeColor from '@/entities/BadgeColor';

const schedulerInnerComponent: InnerComponent = {
	name: 'Badge',
	props: {
		color: BadgeColor.PRIMARY_OUTLINE,
		value: 'New',
		styleClasses:
			'items-baseline leading-normal  font-inherit text-primary-500',
	},
};

export { schedulerInnerComponent };
